(() => {
  const init = (root) => {
    if (root.dataset.gxReady) return;
    root.dataset.gxReady = 'true';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const visual = root.querySelector('[data-hero-visual]');
    root.querySelector('[data-hero-controls]').hidden = false;
    root.querySelectorAll('[data-show-hero]').forEach((button) => {
      button.addEventListener('click', () => {
        const view = button.dataset.showHero;
        visual.querySelectorAll('[data-hero-view]').forEach((panel) => { panel.hidden = panel.dataset.heroView !== view; });
        visual.querySelectorAll('[data-show-hero]').forEach((control) => { control.setAttribute('aria-pressed', String(control === button)); });
        visual.querySelector('[data-hero-index]').textContent = view === 'street' ? '01 / 02' : '02 / 02';
        visual.classList.toggle('gx-showing-guard', view === 'guard');
      });
    });
    const tablist = root.querySelector('[data-guard-tabs]');
    const tabs = Array.from(tablist.querySelectorAll('[data-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-panel]'));
    tablist.setAttribute('role', 'tablist');
    tabs.forEach((tab) => { tab.setAttribute('role', 'tab'); tab.setAttribute('aria-controls', panels.find((panel) => panel.dataset.panel === tab.dataset.tab).id); });
    panels.forEach((panel) => { panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', tabs.find((tab) => tab.dataset.tab === panel.dataset.panel).id); panel.tabIndex = 0; });
    const selectTab = (name, moveFocus = false) => {
      tabs.forEach((tab) => { const selected = tab.dataset.tab === name; tab.setAttribute('aria-selected', String(selected)); tab.tabIndex = selected ? 0 : -1; if (selected && moveFocus) tab.focus(); });
      panels.forEach((panel) => { panel.hidden = panel.dataset.panel !== name; });
      root.querySelectorAll('[data-show-panel]').forEach((hotspot) => { hotspot.setAttribute('aria-pressed', String(hotspot.dataset.showPanel === name)); });
    };
    selectTab('shell');
    root.querySelector('[data-hotspots]').hidden = false;
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', (event) => { event.preventDefault(); selectTab(tab.dataset.tab); });
      tab.addEventListener('keydown', (event) => {
        if (event.key === ' ') { event.preventDefault(); selectTab(tab.dataset.tab); return; }
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); selectTab(tabs[next].dataset.tab, true); }
      });
    });
    root.querySelectorAll('[data-show-panel]').forEach((hotspot) => { hotspot.addEventListener('click', () => selectTab(hotspot.dataset.showPanel, true)); });
    const dialog = root.querySelector('[data-inquiry-dialog]');
    let opener;
    if (typeof dialog.showModal === 'function') {
      root.querySelectorAll('[data-open-inquiry]').forEach((button) => {
        button.hidden = false;
        button.setAttribute('aria-haspopup', 'dialog');
        button.addEventListener('click', () => { opener = button; dialog.showModal(); dialog.querySelector('input:not([type="hidden"])')?.focus(); });
      });
      root.querySelector('[data-close-inquiry]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
      dialog.addEventListener('close', () => { opener?.focus(); });
      const feedback = dialog.querySelector('[data-inquiry-feedback]');
      if (feedback) { dialog.showModal(); feedback.focus(); }
    }
    const rail = root.querySelector('[data-merch-rail]');
    const controls = root.querySelector('[data-rail-controls]');
    const previous = controls.querySelector('[data-rail-prev]');
    const next = controls.querySelector('[data-rail-next]');
    const updateRail = () => {
      const hasOverflow = rail.scrollWidth > rail.clientWidth + 2;
      controls.hidden = !hasOverflow;
      previous.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    };
    const moveRail = (direction) => rail.scrollBy({ left: direction * Math.max(rail.clientWidth * 0.8, 160), behavior: reducedMotion ? 'auto' : 'smooth' });
    previous.addEventListener('click', () => moveRail(-1));
    next.addEventListener('click', () => moveRail(1));
    rail.addEventListener('scroll', updateRail, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(updateRail).observe(rail);
    else window.addEventListener('resize', updateRail);
    updateRail();
    const success = root.querySelector('[data-signup-success]');
    if (success) { success.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' }); success.focus({ preventScroll: true }); }
  };
  const scan = (scope) => scope.querySelectorAll('[data-gx-experience]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document));
  else scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
